'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _ResolveState = require('./ResolveState');

var _ResolveState2 = _interopRequireDefault(_ResolveState);

var _PluginMetadata = require('./PluginMetadata');

var _PluginMetadata2 = _interopRequireDefault(_PluginMetadata);

var _Version = require('../Version');

var _Version2 = _interopRequireDefault(_Version);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 插件依赖约束
 * 
 * @ignore
 * @class DependencyConstraint
 */
var DependencyConstraint = function () {
    /**
     * 创建一个对指定id、版本的依赖约束
     * 
     * @ignore
     * @param {string} id 依赖的插件Id
     * @param {Version} version 依赖的插件版本
     * @memberof DependencyConstraint
     */
    function DependencyConstraint(id, version) {
        (0, _classCallCheck3.default)(this, DependencyConstraint);

        this.id = id;
        this.version = version;
        this.state = _ResolveState2.default.RESOLVABLE;
        this.cause = '';

        this.markResolvable = this.markResolvable.bind(this);
        this.markFailed = this.markFailed.bind(this);
        this.markSuccess = this.markSuccess.bind(this);
    }

    /**
     * 标记为可以解析
     * 
     * @memberof DependencyConstraint
     */


    (0, _createClass3.default)(DependencyConstraint, [{
        key: 'markResolvable',
        value: function markResolvable() {
            this.state = _ResolveState2.default.RESOLVABLE;
            this.cause = '';
        }

        /**
         * 标记为解析失败，并记录原因
         * 
         * @param {string} cause 解析失败的原因 
         * @memberof DependencyConstraint
         */

    }, {
        key: 'markFailed',
        value: function markFailed(cause) {
            this.state = _ResolveState2.default.RESOLVEFAILED;
            this.cause = cause;
        }

        /**
         * 标记为解析成功
         * 
         * @memberof DependencyConstraint
         */

    }, {
        key: 'markSuccess',
        value: function markSuccess() {
            this.state = _ResolveState2.default.resolveSuccess;
            this.cause = '';
        }

        /**
         * 指定插件是否满足当前约束
         * 
         * @param {PluginMetadata} pluginMetadata 指定插件元数据
         * @returns {bool} 如果满足，则返回true，否则返回false
         * @memberof DependencyConstraint
         */

    }, {
        key: 'isSatisfy',
        value: function isSatisfy(pluginMetadata) {
            return this.id === pluginMetadata.id && pluginMetadata.version.compare(this.version) >= 0;
        }
    }]);
    return DependencyConstraint;
}();

exports.default = DependencyConstraint;
//# sourceMappingURL=DependencyConstraint.js.map